import { render } from "./GridCampaniiDetalii.vue?vue&type=template&id=b9c3f324&scoped=true&ts=true"
import script from "./GridCampaniiDetalii.vue?vue&type=script&lang=ts"
export * from "./GridCampaniiDetalii.vue?vue&type=script&lang=ts"

import "./GridCampaniiDetalii.vue?vue&type=style&index=0&id=b9c3f324&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c3f324"]])

export default __exports__